module.exports = __webpack_public_path__ + "static/media/mira_community_header.348aa7e2.png";